/**
 * Blog article: builds the table of contents from the body's H2s (adding ids where missing),
 * and wires the "copy link" share button.
 */
const slug = (text) =>
  text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80) || 'section';

document.querySelectorAll('[data-tv-article]').forEach((root) => {
  const body = root.querySelector('[data-tv-body]');
  const toc = root.querySelector('[data-tv-toc]');
  const list = root.querySelector('[data-tv-toc-list]');

  if (body && toc && list) {
    const headings = Array.from(body.querySelectorAll('h2')).filter((h) => h.textContent.trim());
    const used = new Set();
    headings.forEach((h) => {
      if (!h.id) {
        let id = slug(h.textContent);
        let n = 2;
        while (used.has(id) || document.getElementById(id)) id = `${slug(h.textContent)}-${n++}`;
        h.id = id;
      }
      used.add(h.id);
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${h.id}`;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    if (headings.length > 1) toc.hidden = false;
  }

  root.querySelectorAll('[data-tv-copy]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(btn.dataset.tvCopy);
        btn.classList.add('is-copied');
        btn.setAttribute('aria-label', 'Link copied');
        setTimeout(() => {
          btn.classList.remove('is-copied');
          btn.setAttribute('aria-label', 'Copy link');
        }, 1800);
      } catch (e) {
        window.prompt('Copy this link', btn.dataset.tvCopy);
      }
    });
  });
});

/* Brand review widget: header collapses the body, tabs switch panels. */
document.querySelectorAll('[data-tv-brand]').forEach((widget) => {
  const header = widget.querySelector('[data-tv-brand-toggle]');
  const toggle = () => {
    const collapsed = widget.classList.toggle('is-collapsed');
    header.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
  };
  if (header) {
    header.addEventListener('click', toggle);
    header.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggle();
      }
    });
  }
  const tabs = Array.from(widget.querySelectorAll('[data-tv-brand-tab]'));
  const panels = Array.from(widget.querySelectorAll('[data-tv-brand-panel]'));
  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const id = tab.dataset.tvBrandTab;
      tabs.forEach((t) => {
        const on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach((p) => p.classList.toggle('is-active', p.dataset.tvBrandPanel === id));
    });
  });
});
